"use strict";
export function areEqualGasStrategies(a, b) {
  if (!a || !b) {
    return false;
  }
  const optionalFieldMatch = (fieldA, fieldB) => {
    return fieldA == null || fieldB == null || fieldA === fieldB;
  };
  const requiredFieldsEqual = a.limitInflationFactor === b.limitInflationFactor && a.priceInflationFactor === b.priceInflationFactor && a.percentileThresholdFor1559Fee === b.percentileThresholdFor1559Fee;
  const optionalFieldsMatch = optionalFieldMatch(a.thresholdToInflateLastBlockBaseFee, b.thresholdToInflateLastBlockBaseFee) && optionalFieldMatch(a.baseFeeMultiplier, b.baseFeeMultiplier) && optionalFieldMatch(a.baseFeeHistoryWindow, b.baseFeeHistoryWindow) && optionalFieldMatch(a.minPriorityFeeRatioOfBaseFee, b.minPriorityFeeRatioOfBaseFee) && optionalFieldMatch(a.minPriorityFeeGwei, b.minPriorityFeeGwei) && optionalFieldMatch(a.maxPriorityFeeGwei, b.maxPriorityFeeGwei);
  return requiredFieldsEqual && optionalFieldsMatch;
}
export function getGasPrice(estimate) {
  return "gasPrice" in estimate ? estimate.gasPrice : estimate.maxFeePerGas;
}
export function validateGasFeeResult(gasFee) {
  if (gasFee.value === void 0 || gasFee.error) {
    return void 0;
  }
  return { ...gasFee, value: gasFee.value, error: null };
}
